<template>
    <div class="wework-steps-sync">
        <sync-set ref="syncSet"></sync-set>
        <sync-save ref="syncSave"></sync-save>
        <steps-bottom :is-last-step="isLastStep" :btn-disabled="btnDisabled" @btnClick="onBtnClick"></steps-bottom>
    </div>
</template>

<script>
import StepsBottom from '../../steps-bottom';
import SyncSet from '../../sync-set';
import SyncSave from '../../sync-save';

export default {
    components: {
        StepsBottom,
        SyncSet,
        SyncSave
    },

    props: {
        isLastStep: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            btnDisabled: false
        };
    },

    methods: {
        onBtnClick() {
            if (this.$refs.syncSet.validate()) {
                const reqData = this.$refs.syncSet.getData();
                this.$refs.syncSave.addSyncConfig({ reqData }).then(() => {
                    this.$emit('stepComplete');
                });
            }
        }
    }
};
</script>
<style scoped lang="less">
@import './step-sync.less';
</style>
